import { render, staticRenderFns } from "./shortcutManage.vue?vue&type=template&id=f15d35c4"
import script from "./shortcutManage.vue?vue&type=script&lang=js"
export * from "./shortcutManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f15d35c4')) {
      api.createRecord('f15d35c4', component.options)
    } else {
      api.reload('f15d35c4', component.options)
    }
    module.hot.accept("./shortcutManage.vue?vue&type=template&id=f15d35c4", function () {
      api.rerender('f15d35c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/shortcut/shortcutManage.vue"
export default component.exports